import styled, { css } from 'styled-components';
import type { CardProps } from './CardProps';

export const CardWrapper = styled.div<CardProps>`
    ${({ theme, boxShadow }) => css`
        display: flex;
        flex-direction: column;
        width: 100%;
        background: ${theme.uiBricks.dashboardDrActivityDashboardSkinnyCardBackgroundColor};
        border: ${`1px solid #E4E5E6`};
        border-radius: ${theme.uiBricks.dashboardSkinnyCardBorderRadius};
        box-shadow: ${boxShadow || '0px 5px 20px 0px #0000001A'};
        padding: 16px;
        gap: 16px;
    `}
`;

export const Header = styled.div`
    width: 100%;
`;

export const Content = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
`;

export const Footer = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    padding-top: 16px;
`;
